import React, { useState, Fragment } from "react";
import ReactAudioPlayer from "react-audio-player";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Tooltip } from "reactstrap";
import { Game_BG_MUSIC, COLOR_BLACK } from "edu_lms/constants/type";
import { onDispatchPlayMusic } from "edu_lms/modules/General/actions";

const MusicIcon = ({ onDispatchPlayMusic }) => {
  const [isShowMusic, setIsShowMusic] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);

  const handleToggleShowMusic = () => {
    onDispatchPlayMusic(true);
    setIsShowMusic(!isShowMusic);
  };

  const handleToggleTooltip = () => setOpenTooltip(!openTooltip);

  return (
    <Fragment>
      <i
        style={{
          position: "absolute",
          right: "15px",
          top: "5px",
          padding: "6px",
          width: "30px",
          height: "30px",
          border: `1px solid ${COLOR_BLACK}`,
          borderRadius: "50%",
          zIndex: "999",
        }}
        className={`${
          isShowMusic ? "" : "customs-fa-music"
        } fa fa-music cursor ml-3 hvr-registration`}
        aria-hidden="true"
        onClick={handleToggleShowMusic}
        id="tooltip-music"
      ></i>
      <Tooltip
        isOpen={openTooltip}
        target="tooltip-music"
        toggle={handleToggleTooltip}
      >
        {isShowMusic ? "Tắt nhạc nền" : "Mở nhạc nền"}
      </Tooltip>
      {isShowMusic && (
        <ReactAudioPlayer
          src={Game_BG_MUSIC}
          className="d-none"
          loop
          autoPlay
          controls
        />
      )}
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      onDispatchPlayMusic,
    },
    dispatch
  );
};
export default connect(null, mapDispatchToProps)(MusicIcon);
